import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * A custom element that displays product details (color, size, SKU).
 * This component listens for product select events and updates its content accordingly.
 * It handles updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 *
 * @extends {Component}
 */
class SkreyProductDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event and updates the product details.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

  event.promise
    .then(({ detail }) => {
      if (!detail?.html || detail.htmlApplied) return;

      const { html, resource } = detail;

      const productId = resource?.id ?? detail.productId;

      if (productId) {
        this.dataset.productId = productId;
      }

      const newDetails = html.querySelector('skrey-product-details');

      if (!newDetails) {
        console.log('No skrey-product-details found in updated HTML');
        return;
      }

      morph(this, newDetails, { childrenOnly: true });
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[skrey-product-details] Event promise rejected:', error);
      }
    });
};
}


if (!customElements.get('skrey-product-details')) {
  customElements.define('skrey-product-details', SkreyProductDetails);
}